export default __webpack_public_path__ + "static/media/knowledge is powerful.1bb25a17.webp";